import { render, staticRenderFns } from "./AuthenticationSelf.vue?vue&type=template&id=fb704736&scoped=true"
import script from "./AuthenticationSelf.vue?vue&type=script&lang=js"
export * from "./AuthenticationSelf.vue?vue&type=script&lang=js"
import style0 from "./AuthenticationSelf.vue?vue&type=style&index=0&id=fb704736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb704736",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VFlex,
  VForm,
  VLayout,
  VTextField,
})
